import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../actions/settings";
import DataTable from 'react-data-table-component';
import { IonButton, IonIcon, IonSpinner } from "@ionic/react";
import { createOutline, gitPullRequestSharp } from "ionicons/icons";
import NotificationPopUp from "../../extras/NotificationPopUp";
import { useAppSelector } from "../../../Hooks";
import { selectUser } from "../../../reducers/UserReducer";
import { isStaff } from "../../extras/Functions";
import UploadIntervalDataBtn from "../IntervalDataComponents/UploadIntervalDataBtn";
import usePermissionGroups from "../../../utils/usePermissionGroups";
import ConfirmDeleteBtnModal from "../Modals/ConfirmDeleteBtnModal";
import useToggle from "../../../utils/useToggle";

interface IProps {
    id:string
};

async function pullData(
  token: string,
  id: string,
) {
  return fetch(`${API_URL}/energystar/property/${id}/pull_meter_estar_data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then(async (res: any) => {
    if (res.ok) {
      NotificationPopUp("success","Meter Data Pulled From Energy Star")
      return true
    } else {
      const data = await res.json();
      return {
        error: data.error,
      };
    }
  });
}

async function getMeters(token: string, id: string,type:string) {
  return fetch(`${API_URL}/buildings/${id}/${type}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) =>
    res.json());
}

const MeterListTable:FC<IProps> = ({id}) => {
    let params = new URLSearchParams(window.location.search);
    const [data,setData] = useState([])
    const [error,setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const user = useAppSelector(selectUser)
    const [tab,setTab] = useState<string | null>(null)
    const url_tab = params.get("m");
    const [reload, toggleReload] = useToggle()

    const { hasPermission } = usePermissionGroups()
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

  
    

    const copyUUID = (id:string) => {
        navigator.clipboard.writeText(id);
        const popup = document.getElementById(`copy-${id}`);
        popup?.classList.toggle("show");
        setTimeout(() => {
          const popup = document.getElementById(`copy-${id}`);
          popup?.classList.toggle("show");
        }, 3000);
      };


    useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
      const type = tab === 'estar' ? 'meters' : `${tab}_meters`
      const res = await getMeters(token, id, type);
      if(res.error){
        setError(res.error)
      }
      else {
        if (tab === 'estar'){
          setData(res.data.filter((row:any) => !row.is_virtual))
        }else setData(res.data)
      }
    };
    if(tab){
      handleData();
    }
  }, [id,tab,reload]);

  useEffect(()=>{
      if (url_tab){
        setTab(url_tab)
        const button = document.querySelector(`#${url_tab}_meters_button`)
        button?.classList.add('selected')
      }
      else{        
        setTab('estar')
        const button = document.querySelector(`#estar_meters_button`)
        button?.classList.add('selected')
      }
    },[url_tab])

  const handleMenuClick = (e:any, tab:string) => {
    params.set('m',tab)
    window.history.replaceState({},"",`?${params}`)
    setTab(tab)
    const buttons: NodeListOf<Element>  = document.querySelectorAll(".meters-menu-button")
    buttons.forEach((button:any)=>{
        button.classList.remove('selected')
    })
    e.target.classList.add('selected')
  }


  const handlePullData = async () => {
    setLoading(true)
      const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
      const res = await pullData(token, id);
      setLoading(false);
      if (res){
        window.location.href=`/?id=${id}&sec=buildings&t=meters`;
      }
    };

  const columns = [
        {
            name: 'Name',
            selector: (row:any) => {

                return <div>
                    <a href={`/energystar/meters/${row.id}`}><span style={{fontWeight:'bold', color:'white',textDecoration:'underline',textDecorationColor:'white'}}>{row.name}</span></a>
                    <div style={{fontSize:'smaller'}}>{row.meter_id}</div>
                </div> 
            },
            sortable: true,
        },
        {
            name: 'Meter Type',
            selector: (row:any) => {

                return row.type.name
            },
            sortable: true,
        },
        {
            name: 'In Use?',
            selector: (row:any) => {
                
                if(row.inuse){
                    return "Active"
                }
                else{
                    const date = new Date(row.inactivedate)
                    const full_date =  `${date.getUTCMonth()+1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
                    return <div>
                        <div>Not in Use</div>
                        <div>({full_date})</div>
                    </div>
                }
            },
            sortable: false,
        },
        {
            name: 'Latest Bill Date',
            selector: (row:any) => {
                const date = new Date(row.latest_bill_date)
                return `${date.getUTCMonth()+1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
            },
            sortable: false
        },
        {
            name: 'Cost Avoidance Method',
            selector: (row:any) => row.baseline_adjustment_method ? row.baseline_adjustment_method.name : '',
            sortable: false,
        },
        // {
        //     name: "Upload Interval Data",
        //     selector: (row:any) => <UploadIntervalDataBtn id={row.id}/>,
        //     sortable:false,
        //     maxWidth: '150px',
        //     // omit: !hasPermission(['canDeleteIntervalData'])
        // },
    ];

    const internal_meters_columns = [
        {
          name: 'ID',
          selector: (row:any) => {

            return <div style={{fontSize:'smaller',display:'flex',alignItems:'center'}}>
              <span className="popup">
              <span className="popuptext" id={`copy-${row.id}`}>
                    Copied
                  </span>
              <IonButton size="small" fill="clear" style={{color:'white',fontSize:'10px'}} onClick={() => copyUUID(row.id)}>
                <div>{row.id}</div>
              </IonButton>
              </span>
              
              </div>
          },
        },
        {
            name: 'Name',
            selector: (row:any) => {

                return <div>
                  <a href={`/internal_meter/${row.id}`}><span style={{fontWeight:'bold', color:'white',textDecoration:'underline',textDecorationColor:'white'}}>{row.name}</span></a> 
                </div> 
            },
            sortable: true,
        },
        {
            name: 'Meter Type',
            selector: (row:any) => {

                return row.type.name
            },
            sortable: true,
        },
        {
            name: 'Units',
            selector: (row:any) => {

                return <div>{row.unitofmeasure}</div>
            },
            sortable: true,
        },
        {
            name: "Upload",
            selector: (row:any) => <UploadIntervalDataBtn id={row.id}/>,
            sortable:false,
            maxWidth: '150px',
            omit: !hasPermission(['canDeleteIntervalData'])
        },
        {
            name: 'Delete',
            selector: (row:any) => {

                const handleDelete = async () => {
                  const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
                    const res = await fetch(`${API_URL}/buildings/meter/${row.id}`,{
                        method:"DELETE",
                        headers:{
                            "Content-Type":"application/json",
                            "Accept":"application/json",
                            "Authorization": token
                        }
                    }).then(res=>res.json())
                    if(res.error){
                        NotificationPopUp("error",res.error)
                    }
                    else{
                        NotificationPopUp("success","Meter Deleted")
                        toggleReload()
                    }
                }

                return <div>
                    <ConfirmDeleteBtnModal id={id} handleDelete={handleDelete} />
                  </div>
            },
            button: true,
            omit: !isStaff(user),
            maxWidth: '150px'

        }
      ]


    const virtual_meter_columns = [
        {
            name: 'Name',
            selector: (row:any) => {

                return <div>
                  <a href={`/virtual_meter/${row.id}`}><span style={{fontWeight:'bold', color:'white',textDecoration:'underline',textDecorationColor:'white'}}>{row.name}</span></a> 
                </div> 
            },
            sortable: true,
        },
        {
            name: 'Meter Type',
            selector: (row:any) => {

                return row.type.name
            },
            sortable: true,
        },
        {
            name: 'Units',
            selector: (row:any) => {

                return <div>{row.unitofmeasure}</div>
            },
            sortable: true,
        },
        {
            name: "Number of Meters",
            selector: (row:any) => {return row.source_meter_ids ? row.source_meter_ids.length : 0},
            sortable:false,
            maxWidth: '150px',            
        },
        {
            name: 'Edit',
            selector: (row:any) => {
                return <IonButton size="small" color="medium" href={`/virtual_meter/${row.id}/edit`}>
                  <IonIcon src={createOutline}/>
                </IonButton>
            },
            button: true,
            omit: !isStaff(user),
            maxWidth: '100px',  

        },
        {
            name: 'Delete',
            selector: (row:any) => {

                const handleDelete = async () => {
                  const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
                    const res = await fetch(`${API_URL}/virtual_meters/${row.id}`,{
                        method:"DELETE",
                        headers:{
                            "Content-Type":"application/json",
                            "Accept":"application/json",
                            "Authorization": token
                        }
                    }).then(res=>res.json())
                    if(res.error){
                        NotificationPopUp("error",res.error)
                    }
                    else{
                        NotificationPopUp("success","Meter Deleted")
                        toggleReload()
                    }
                }

                return <div>
                    <ConfirmDeleteBtnModal id={id} handleDelete={handleDelete} />
                  </div>
            },
            button: true,
            omit: !isStaff(user),
            maxWidth: '150px'

        }
      ]

    const noMeters = <div>
            <div>{error}</div>
            {isStaff(user) ?
            <div>
            <div>
              Click Button to Pull Meter Data From Energy Star.</div>
            <IonButton size="small" color="medium" disabled={loading} title="Pull Meter Data" onClick={()=>handlePullData()}>
                {loading ? <IonSpinner /> : <IonIcon src={gitPullRequestSharp}/>}
            </IonButton>
            </div> : null
            }
        </div>

    
    function getTitle(){
      switch(tab){
        case 'estar':
          return <div style={{display:'flex',justifyContent:'space-between'}}>
            <div>Meters</div>
            {isStaff(user) ? 
            <IonButton size="small" color="medium" disabled={loading} title="Pull Meter Data" onClick={()=>handlePullData()}>
                {loading ? <IonSpinner /> : <IonIcon src={gitPullRequestSharp}/>}
            </IonButton>: null
            }
          </div>

        case 'internal':
          return <div style={{display:'flex',justifyContent:'space-between'}}>
            <div>Internal Meters</div>
            {isStaff(user) ? 
            <IonButton size="small" color="medium" disabled={loading} title="Add Meter" href={`/building/${id}/meters`}>
                {loading ? <IonSpinner /> : "Add Meter"}
            </IonButton>: null
            }
          </div>

        case 'virtual':
          return <div style={{display:'flex',justifyContent:'space-between'}}>
            <div>Combined Meters</div>
            {isStaff(user) ? 
            <IonButton size="small" color="medium" disabled={loading} title="Add Meter" href={`/virtual_meter/${id}/create`}>
                {loading ? <IonSpinner /> : "Add Meter"}
            </IonButton>: null
            }
          </div>

        default:
            return ''
      }

    }
    

    
    function get_columns() {
      switch(tab) {
          case 'estar':
              return columns;
          case 'internal':
              return internal_meters_columns;
          case 'virtual':
              return virtual_meter_columns;
          default:
              return [];
      } 
    }


    
    return <div style={{marginBottom:'12rem'}}>
      { isStaff(user) ?
      <div style={{display:'flex',justifyContent:'center',marginBottom:'0.5rem',marginTop:'0.5rem'}}>
        <div style={{borderBottom:'1px solid white'}}>
        <IonButton id='estar_meters_button' 
        className= { tab === 'estar' ?  "selected meters-menu-button" : 'meters-menu-button'}
        fill='clear' color={newUI ? 'dark' : 'light'}
        onClick={(e)=>handleMenuClick(e,'estar')}>Utility Meters</IonButton>
        <IonButton id='internal_meters_button' className={ tab === 'internal' ?  "selected meters-menu-button" : 'meters-menu-button'} fill='clear' color={newUI ? 'dark' : 'light'} onClick={(e)=>handleMenuClick(e,'internal')}>Internal Meters</IonButton>                
        <IonButton id='virtual_meters_button' className={ tab === 'virtual' ?  "selected meters-menu-button" : 'meters-menu-button'} fill='clear' color={newUI ? 'dark' : 'light'} onClick={(e)=>handleMenuClick(e,'virtual')}>Combined Meters</IonButton>                
      </div>
      </div> : null }
      { error && tab=== 'estar' ? noMeters :
      <DataTable
          title={getTitle()}
          columns={ get_columns()}
          data={data}
          pagination
          theme='dark'

        /> }
        </div>
};

export default MeterListTable;